import { reverseOffset } from './functions';

type FirestoreDateLike =
  | Date
  | null
  | undefined
  | {
      toDate: () => Date;
    };

const toJsDate = (value: FirestoreDateLike) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value.toDate === 'function') return value.toDate();
  return null;
};

// For an event date as shown in the app (offset on read): converts it back to the stored form.
export const normalizeGigEventDate = (eventDate: FirestoreDateLike) => {
  const jsDate = toJsDate(eventDate);
  const normalizedDate = reverseOffset(jsDate);

  if (!normalizedDate) {
    throw new Error('Gigs require an event date before they can be saved.');
  }

  return normalizedDate;
};

// For an event date already in stored form (read straight from Firestore, or already converted by
// sanitizeDiff): copied as-is. Converting it again moves the gig to the evening before.
export const storedGigEventDate = (eventDate: FirestoreDateLike) => {
  const jsDate = toJsDate(eventDate);

  if (!jsDate || isNaN(jsDate.getTime())) {
    throw new Error('Gigs require an event date before they can be saved.');
  }

  return jsDate;
};

export const getGigEventLink = (relEventId: string | null | undefined, eventDate: FirestoreDateLike) => {
  if (!relEventId) {
    throw new Error('Gigs require an event before they can be saved.');
  }

  return {
    relEventId,
    relEventDate: normalizeGigEventDate(eventDate)
  };
};